<template>
  <div>
    <a-modal
      :title="title"
      :visible="visible"
      width="450px"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-form
        @submit="handleSubmit"
        :form="form"
      >
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="头像"
              :labelCol="{lg: {span: 6}}"
              :wrapperCol="{lg: {span: 18} }"
              style="margin-bottom:5px;"
            >
              <upload ref="upload" :length="1" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" uploadTest="头像"></upload>
            </a-form-item>
            <a-form-item
                label="姓名"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-input placeholder="请输入运动员姓名" v-decorator="['name', { rules: [{required: true, message: '请输入运动员姓名!'}]}]"/>
            </a-form-item>
            <a-form-item
                label="职务"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }">
              <a-select placeholder="选择职务类型" :disabled="userInfo.remark === '北京学校账号'" v-decorator="['type', { rules: [{required: true, message: '请输选择职务'}]}]">
                <a-select-option v-for="(item, index) in matchFun.staffTypeEnum()" :value="item.code" :key="index">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
                label="负责项目"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-select placeholder="请选择负责项目" mode="multiple" v-decorator="['programIds',{ rules: [{ required: true, message: '请选择负责项目' }] },]">
                <a-select-option :value="item.programId + ''" v-for="(item, index) in agencyProgram" :key="index">{{item.name}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
                label="联系电话"
                :labelCol="{lg: {span: 6}}"
                :wrapperCol="{lg: {span: 18} }"
            >
              <a-input placeholder="请输入联系电话" v-decorator="['mobile', { rules: [{required: true, message: '请输入联系电话'}]}]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import matchFun from '@comm/utils/matchFun'
import Upload from '@comm/upload/Upload'
export default {
  components: {
    Upload
  },
  data () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      image: [],
      matchFun: matchFun,
      data: null,
      title: '新增成员'
    }
  },
  computed: {
    ...mapState({
      agencyInfo: state => state.agency.agencyInfo,
      agencyProgram: state => state.agency.agencyProgram,
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    show (data) {
      this.data = data
      this.image = []
      this.visible = true
      if (data !== null) {
        this.title = '修改成员信息'
        this.formData(this.data)
        this.image.push(this.matchFun.randomNumFile('image.jpg', data.image))
      } else {
        this.$nextTick(function () {
          this.form.setFieldsValue({
            name: '',
            type: 'COACHMAIN',
            programIds: [],
            mobile: ''
          })
        })
      }
    },
    formData (data) {
      setTimeout(() => {
        this.form.setFieldsValue({
          name: data.name,
          type: data.type,
          programIds: this.calProgramList(data.programs),
          mobile: data.mobile
        })
      })
    },
    calProgramList (programs) {
      let arr = []
      if (programs !== null) {
        programs.split(',').forEach(element => {
          arr.push(element.split(';')[0])
        })
      }
      return arr
    },
    uploadSuccess (e) {
      this.image = e
    },
    handleSubmit (e) {
      e.preventDefault()
      if (this.image.length === 0) {
        this.$message.error('请上传头像')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          values.agencyId = this.agencyInfo.agencyId
          values.image = this.image[0].url
          if (this.data === null) {
            this.add(values)
          } else {
            values.id = this.data.id
            this.update(values)
          }
        }
      })
    },
    add (values) {
      this.$api.match.agencyStaffAdd(values).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.handleCancel()
        } else {
          this.$message.error(`失败`)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    update (values) {
      this.$api.match.agencyStaffUpdate(values).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.handleCancel()
        } else {
          this.$message.error(`失败`)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleCancel () {
      this.$emit('ok')
      this.visible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/center/modal/EditCoach.vue